import { render, staticRenderFns } from "./fullname-cell.vue?vue&type=template&id=49eddbfa&"
import script from "./fullname-cell.vue?vue&type=script&lang=js&"
export * from "./fullname-cell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49eddbfa')) {
      api.createRecord('49eddbfa', component.options)
    } else {
      api.reload('49eddbfa', component.options)
    }
    module.hot.accept("./fullname-cell.vue?vue&type=template&id=49eddbfa&", function () {
      api.rerender('49eddbfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-table/candidates/fullname-cell.vue"
export default component.exports